import store from '../state/store';
import { isAuthenticated } from '../state/store';
import api from './api.services';
import customAlert from '../utils/customAlert/customAlert';
import i18n from '@/plugins/i18n';
import router from '@/router/index.js';
import { getMenuItems } from '../config/menuItems';

const authService = {
  login(credentials = {}) {
    return new Promise((resolve, reject) => {
      api
        .post('login', {
          email: credentials.email,
          password: credentials.password
        })
        .then((res) => {
          if (['210', '209'].includes(res?.data?.codResposta)) {
            resolve(res);
            return;
          }
          if ([200].includes(res?.status)) {
            store.commit('SET_AUTHENTICATED', true);
            this.updateSession(res.data);
            i18n.locale = res.data?.user.settings?.language || 'en';
            resolve(res);
            return;
          }
          reject(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  secondStepLogin(data = {}) {
    return new Promise((resolve, reject) => {
      api
        .post('second_step', {
          totp: data.totp,
          accessToken: data.accessToken
        })
        .then((res) => {
          if ([200, '200'].includes(res?.status)) {
            store.commit('SET_AUTHENTICATED', true);
            this.updateSession(res.data);
            i18n.locale = res.data?.user.settings?.language || 'en';
            resolve();
            return;
          }
          if ([200].includes(res?.status)) {
            resolve(res);
            return;
          }
          reject(res);
        })
        .catch((err) => {
          console.log('second step login error', err);
          reject(err);
        });
    });
  },
  logout(display_alert = true) {
    if (display_alert) {
      customAlert({
        msg: i18n.t('You will be logged out'),
        type: 'success'
      });
    }

    const redirect_to = this.logoutRoute();
    localStorage.clear();

    router.push(redirect_to);
  },
  logoutRoute() {
    if (store?.state?.isAuthenticated == true) {
      return '/login';
    }
    return '/';
  },
  updateSession(session = {}) {
    if (!session || !session.user) {
      return;
    }

    try {
      localStorage.setItem('accessToken', session.accessToken);
      localStorage.setItem('accessExpiresAt', session.accessExpiresAt);
      localStorage.setItem('refreshExpiresAt', session.refreshExpiresAt);
      localStorage.setItem('refreshToken', session.refreshToken);
      localStorage.setItem('user', JSON.stringify(session.user));

      if (session.user?.company?.id) {
        const companySettings = session.user.company.settings || {};

        localStorage.setItem(`company_${session.user.company.id}_settings`, JSON.stringify(companySettings));
      }

      store.commit('SET_SESSION', session);

      try {
        const menuItems = getMenuItems();
        store.commit('SET_MENU_ITEMS', menuItems);
      } catch (menuErr) {
        console.error('Erro ao carregar menu items:', menuErr);
        store.commit('SET_MENU_ITEMS', []);
      }
    } catch (err) {
      console.error('Erro ao atualizar sessão:', err);
    }
  },
  getSession() {
    if (isAuthenticated) {
      return {
        accessToken: localStorage.getItem('accessToken'),
        accessExpiresAt: localStorage.getItem('accessExpiresAt'),
        refreshExpiresAt: localStorage.getItem('refreshExpiresAt'),
        refreshToken: localStorage.getItem('refreshToken'),
        user: localStorage.getItem('user')
      };
    }
    return {};
  },
  getLoggedUser() {
    return JSON.parse(localStorage.getItem('user') || '{}');
  }
};

export default authService;
